import React from 'react'
import PropTypes from 'prop-types'

export const createDivAtom = () => props => (
  <div {...props}>
    { props?.children }
  </div>
)

createDivAtom.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ])
}
